<template>
  <div id="app" :style="{'background-color': baseColor}">

    <!-- page main wrapper start -->
    <main style="background-color:#ffffff" id="start">
        <!-- contact wrapper area start -->
    <div class="contact-top-area" style="background-color:#ffffff">
        <div class="row"  v-if="!isPamentPage" style="display:block;margin:auto;">
              <a href="/"><img  :src="picture" style="display:block;margin:auto;"></a>
        </div>
    <div>
         <div class="text-center pt-20 pb-20" :style="{'background-color': baseColor}">
                     <a href="/"> <h1 style="color:#ffffff">{{storename}}</h1></a>
            </div>
    </div>
        <div class="container"  v-if="!isPamentPage">
            
            <div class="row pt-30">
                <div class="col-lg-24 col-md-24 col-sm-24">
                    <div class="footer-widget">
                        <div class="section-title ">
                            <h2>WELKOM</h2>
                        </div>
                        <div class="footer-widget-body">
                            <p v-html="welcomemsg"></p>
                        </div>
                    </div>
                </div>                   
            </div>
            <div class="row pt-30">
            </div>
        </div>
        <div style="background-color:#ffffff;">
        <div class="container anchor" id="reserveer" v-if="onlinesresclosed === false">
            <div class="row  pt-30">
                <div class="footer-widget">
                    <div class="section-title ">
                        <h2>RESERVEER ONLINE</h2>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <appReservation  style="background-color:#fafafa;padding-top:10px;padding-bottom:15px" v-if="onlinesresclosed === false"  />
        <div class="container anchor" id="contact" style="background-color:#ffffff">
            <div class="row pt-20">
                
            </div> <!-- section title end -->
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="contact-single-info mb-30 text-center">
                        <div class="contact-icon" :style="{'background-color': baseColor}">
                            <i class="fa fa-map-marker"></i>
                        </div>
                        <h3>Adresgegevens</h3>
                        <p>{{address1}}<br>{{address2}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="contact-single-info mb-30 text-center">
                        <div class="contact-icon" :style="{'background-color': baseColor}">
                            <i class="fa fa-phone"></i>
                        </div>
                        <h3>Contact</h3>
                        <p>{{phone}}<br>{{mobile}}</p>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="contact-single-info mb-30 text-center">
                         <div class="contact-icon" :style="{'background-color': baseColor}">
                            <i class="fa fa-facebook"></i>
                        </div>
                        <h3>Social</h3>
                        <p><a style="color:#111111" :href="facebookurl" target="_blank">Facebook</a></p>
                        <p style="color:#111111" v-if="hasinstagram"><a style="color:#111111" :href="instagramurl" target="_blank">Instagram</a></p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="contact-single-info mb-30" v-if="openhours.length > 5">
                        <h3>Openingsuren</h3>
                        <p v-html="openhours"></p>
                    </div>
                </div>
            </div>
        </div>
        <div style="background-color:#fafafa;">
        <div class="container">
            
            <div class="row" style="background-color:#fafafa;">
                <div class="col-xl-20 col-lg-24 m-auto">
                    <div class="row pt-30">
                        <div class="col-24">
                            <div class="section-title ">
                                <h2>ZEND EEN BERICHT</h2>
                            </div>
                        </div>
                    </div> <!-- section title end -->

                    <div class="contact-message pt-60 pt-sm-20">
                       
                            <div class="row" v-if="!flgContactSend">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <input name="first_name" placeholder="Naam *" type="text" v-model="clientname">    
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <input name="phone" placeholder="Telefoon *" type="text" v-model="clientphone">   
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <input name="email_address" placeholder="Email *" type="text" v-model="clientmail">    
                                </div>
                                 <div class="col-lg-12 col-md-12 col-sm-12" v-if="captchaimg.length > 100">
                                    <div class="row"> 
                                    <div class="col-lg-12 col-md-12 col-sm-12"><img :src="captchaimg" v-if="captchaimg.length > 100" ></div>
                                    <div class="col-lg-12 col-md-12 col-sm-12"><input v-model="captchacode" name="captchacode" placeholder="code" type="text">    </div> 
                                    </div>
                                </div>
                               <div class="col-24">
                                    <div class="contact2-textarea text-center">
                                        <textarea placeholder="Bericht *" name="message"  class="form-control2" required="" v-model="clientmessage"> </textarea>     
                                    </div>   
                                    <div class="contact-btn text-center" v-if="captchaimg.length > 100">
                                        <button :disabled="disableSendMsg" class="check-btn sqr-btn" type="submit" :style="{'background-color': baseColor}" @click="sendContact ()">Verzenden</button> 
                                    </div> 
                                    <div class="text-center pt-20">
                                        <h3 style='color:#ff0000'>{{errormsg}}</h3>
                                    </div>
                                </div> 
                            </div>
                            <div class="row" v-if="flgContactSend">
                                <div class="text-center pt-20">
                                        <h3 style='color:#ff0000'>{{errormsg}}</h3>
                                </div>
                            </div>
                    </div> 
               </div>
           </div>
            </div>
        </div>
    </div>
    <!-- contact wrapper area end -->
    </main>
    <!-- page main wrapper end -->

    <!-- footer area start -->
    <footer>

        <!-- footer widget area start -->
        <div class="footer-widget-area pt-30 pb-30 pb-md-20 pt-sm-36 pb-sm-10">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-24">
                        <div class="footer-widget">
                            <div class="footer-widget-title" v-if="bottomtitle1.length > 2">
                                <h3 style="color:#eeeeee">{{bottomtitle1}}</h3>
                            </div>
                            <div class="footer-widget-body"  v-if="bottommsg1.length > 10">
                                <span class="footermsg" v-html="bottommsg1"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-24">
                        <div class="footer-widget">
                            <div class="footer-widget-title"  v-if="bottomtitle2.length > 2">
                                <h3 style="color:#eeeeee" >{{ bottomtitle2}}</h3>
                            </div>
                            <div class="footer-widget-body" v-if="bottommsg2.length > 10">
                                <span style="color:#ffffff" v-html="bottommsg2"></span>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
        <div class="container"><div class="row pt-10" style="color:#dddddd;text-align:center">Powered by  &nbsp; <a style="color:#ffffff" href="https://www.posworld.be" target="_blank">Posworld</a>
        <span style="font-size:smaller">&nbsp;&nbsp;{{versionApp}}</span></div></div>
        <!-- footer widget area end -->

    
    </footer>
    <!-- footer area end -->

    <!-- Scroll to top start -->
    <div class="scroll-top not-visible" @click="scrollToTop">
        <i class="fa fa-angle-up"></i>
    </div>
    <!-- Scroll to Top End -->


  </div>
</template>


<style lang="scss">
@import '../static/sites/site-10/assets/css/style.css';
</style>

<script>

import $ from 'jquery'
import Vue from 'vue';
import myHttpApi from "./api/myhttpapi"
import appReservation from './AppReservation';

export default {
  name: 'app',
  data () {
    return {
      isLoading: false,
      hasinstagram : false,
      isPamentPage : false,
      baseColor : '#000000',
      textColor : '#ffffff',
      address1 : 'Adresgegevens',
      address2 : 'Postcode Stad',
      phone : 'Telefoon',
      mobile: 'Mobiel',
      facebook : 'facebook',
      welcomemsg : '',
      bottomtitle1 : '',
      bottomtitle2 : '',
      bottommsg1 : '',
      bottommsg2 : '',
      openhours : '',
      picture : '',
      storename : '',
      captchaimg : '',
      onlinesresclosed : false,
      clientname : '',
      clientphone : '',
      clientmail : '',
      captchacode : '',
      mytokencode : '',
      clientmessage : '',
      disableSendMsg : false,
      flgContactSend : false,
      errormsg : '',
      facebookurl : '',
      instagramurl : ' ',
      titleApp : '',
      versionApp : ''
    }
  },
  components: {
     appReservation
  },
  created () {
      
      document.title = "Reserveer online bij " + Vue.$storeSettings.StoreName

      if (Vue.$storeSettings.IsStoreClosed)
      {
          document.title = "Welkom bij " + Vue.$storeSettings.StoreName
      }

      this.versionApp = Vue.$version;
      this.flgContactSend = false;

      this.isPamentPage = false; 
      if (this.$route.name == "PaymentStatus") this.isPamentPage = true; 
      if (this.$route.name == "CustAppoint") this.isPamentPage = true;   //We verbergen ook bij wissen ?

      this.onlinesresclosed = Vue.$storeSettings.IsStoreClosed
      this.baseColor = Vue.$storeSettings.ColorApp
      this.picture = Vue.$urlCDN + '/Images/Minisite/Posworldmain1.jpg'
      this.storename = Vue.$storeSettings.StoreName
      var jsData = JSON.parse(Vue.$storeSettings.ShopSiteData)
      this.bottommsg1 = jsData.JsonData.msgfootnote1
      this.bottommsg2 = jsData.JsonData.msgfootnote2
      this.bottomtitle1 = jsData.JsonData.msgfoottitle1
      this.bottomtitle2 = jsData.JsonData.msgfoottitle2
      this.openhours = jsData.JsonData.openhours
      this.address1 = jsData.JsonData.address
      this.address2 = jsData.JsonData.postalcode
      this.mobile = jsData.JsonData.mobile
      this.phone = jsData.JsonData.phone
      this.welcomemsg = jsData.JsonData.msgwelcome
      this.facebookurl = jsData.JsonData.facebook
      this.instagramurl = jsData.JsonData.instagram
      if (jsData.JsonData.urlmainpicture != undefined) {
        if (jsData.JsonData.urlmainpicture.length > 10) {
            this.picture = jsData.JsonData.urlmainpicture
        }
      }
      
      if (this.instagramurl != undefined) {
          if (this.instagramurl.length > 10) this.hasinstagram = true;
      }

      if (this.bottomtitle1 === undefined) this.bottomtitle1 = '';
      if (this.bottomtitle2 === undefined) this.bottomtitle2 = '';
      if (this.bottommsg1 === undefined) this.bottommsg1 = '';
      if (this.bottommsg2 === undefined) this.bottommsg2 = '';
      if (this.openhours === undefined) this.openhours = '';

      this.errormsg = ''
      this.loadCaptcha ();
  },
  computed: {
  },
  methods: {
      navigate (item) {
        //this.$router.push(item);
      },
      navigateBack () {
        //this.$router.go(-1);
      },
      scrollToTop () {
          $('html,body').animate({
                scrollTop: 0
            }, 1000);
      },
      loadCaptcha () {
        myHttpApi.post( 'Settings/GetCaptcha')
        .then(response => {
            this.mytokencode = response.data.Token
            this.captchaimg  = "data:image/jpeg;base64," +  response.data.Base64;
        })
        .catch(error => {
            //Hide module
            //this.$store.commit(SPINNER_HIDE);
        })
      },
     sendContact () {
        this.disableSendMsg = true
        this.flgContactSend = false
        var msg = {Token : this.mytokencode, Key: this.captchacode, Name : this.clientname , Email: this.clientmail, Phone: this.clientphone, Message: this.clientmessage  }
        myHttpApi.post( 'Settings/SendContact', msg)
        .then(response => {
            var result = response.data;
            if (result.ResultCode == 200)
            {
                this.flgContactSend = true
                this.errormsg = "Bedankt!"
            }
            else
            {
                this.errormsg = result.ErrorMsg
                this.disableSendMsg = false
            }
            
        })
        .catch(error => {
           this.disableSendMsg = false
        })
      }
      
    },
}

</script>


<style scoped>
a.anchor {
    display: block;
    position: relative;
    top: 50px;
    visibility: hidden;
}
.containerImg {
  position: relative;
  text-align: center;
  color: white;
}
.centered {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img30pct  {
    max-height: 450px; overflow: hidden;
}
.img30pct img { max-height: initial; /* Maybe optional. See note below */ }

</style>


// WEBPACK FOOTER //
// src/AppWebsiteV10.vue